import { render, staticRenderFns } from "./labelTooltip-editor.vue?vue&type=template&id=4bb85541&scoped=true&"
import script from "./labelTooltip-editor.vue?vue&type=script&lang=js&"
export * from "./labelTooltip-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb85541",
  null
  
)

export default component.exports